import { useEffect, useMemo, useRef } from 'react';
import { debounce } from 'lodash';

const useDebounce = (fn, ms = 500) => {
  // Stable reference to the latest function
  const refFn = useRef(fn);
  useEffect(() => {
    refFn.current = fn;
  }, [fn]);

  const debouncedFn = useMemo(() => debounce(refFn.current, ms), [ms]);

  // Prevents pending calls from being executed after unmounting
  useEffect(() => () => {
    debouncedFn.cancel();
  }, [debouncedFn]);

  return debouncedFn;
};

export default useDebounce;
